// Configuration file for API endpoints
// Change these values when deploying to production

const isDevelopment = process.env.NODE_ENV === 'development';

// Backend API URL
// Development: http://localhost:8000
// Production: https://carsambacigkofte.com/backend
export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8000' 
  : 'https://carsambacigkofte.com/backend';

// Full API endpoint
export const API_URL = `${API_BASE_URL}/api.php`;

// Image base URL for uploaded images
export const IMAGE_BASE_URL = isDevelopment
  ? 'http://localhost:8000'
  : 'https://carsambacigkofte.com/backend';

// Frontend URL for CORS (used in backend)
export const FRONTEND_URL = isDevelopment
  ? 'http://localhost:3000'
  : 'https://carsambacigkofte.com';

// Contact Information
export const CONTACT_INFO = {
  phone: '+90 (212) 123-4567', // TODO: Update with your phone number
  phoneRaw: '02121234567', // For tel: links (without +90)
  whatsapp: '902121234567', // TODO: Update with your WhatsApp number (with country code, no +)
  email: 'info@resumecigkofte.com', // TODO: Update with your email
  emailOrder: 'siparis@resumecigkofte.com', // TODO: Update with your order email
  address: {
    line1: 'Kirazlı Çay Mah, Değirmen Başı Cad.',
    line2: 'No:67/A-C A Blok Şeker Evleri'
  },
  workingHours: 'Pazartesi-Pazar: 11:00-22:00' // TODO: Update with your working hours
};

// Social Media Links
export const SOCIAL_MEDIA = {
  facebook: 'https://facebook.com/yourpage', // TODO: Update with your Facebook page
  instagram: 'https://instagram.com/yourpage', // TODO: Update with your Instagram
  twitter: 'https://twitter.com/yourpage' // TODO: Update with your Twitter
};

// Google Maps Embed URL
// Get your embed URL from: https://www.google.com/maps -> Share -> Embed a map
export const GOOGLE_MAPS_EMBED = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.5658317589346!2d29.0054!3d41.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14caa7a5c5c5c5c5%3A0x0!2sBeşiktaş%2C%20İstanbul!5e0!3m2!1str!2str!4v1234567890';
// TODO: Update with your actual location's Google Maps embed URL

